import FieldsInput from "../../../../components/FieldComponents/FieldsInput";
import { mergeClasses } from "@fluentui/react-components";
import Style from "../../../Client/ClientManagement/AddClient.style";
import { Stack } from "@fluentui/react";
import { useTranslation } from "react-i18next";

const UserCity = (props) => {
  const { userCity } = props;
  const { t } = useTranslation();
  const style = Style();
  return (
    <>
      <Stack className={style.client_field}>
        <FieldsInput
          label={t("city")}
          validationMessage={props.errors?.userCity?.message}
          id="userCity"
          placeholder={t("enter_city")}
          name="userCity"
          inputDefaultValue={userCity}
          inputClassName={mergeClasses(style.textboxInput)}
          validation={props.register("userCity")}
          noRequired
        />
      </Stack>
    </>
  );
};

export default UserCity;
